import { render, staticRenderFns } from "./NewsDetailShow.vue?vue&type=template&id=9c87be6e"
import script from "./NewsDetailShow.vue?vue&type=script&lang=js"
export * from "./NewsDetailShow.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailShow.vue?vue&type=style&index=0&id=9c87be6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports